import { useContext } from 'react';

import { UppyUploadContext } from '..';

export const useUppyUploadContext = () => useContext(UppyUploadContext);
